import React, { useState } from "react";
import MainLogo from "../../assets/images/main-logo.png";
import Map from "../../assets/images/map.png";
import { Link } from "react-router-dom";
import { axiosInstance, config } from "../../pages/config";
import Loader from "./Loader";
import { notification } from "antd";
import { useInView } from 'react-intersection-observer';

const Footer = () => {
  const year = new Date().getFullYear();

  const [email, setEmail] = useState("");
  const [isLoading, setLoading] = useState(false);

  const onHandleSubmit = async (e) => {
    console.log("first");
    e.preventDefault();
    setLoading(false);
    try {
      const formData = new FormData();
      formData.append("email", email);
      const res = await axiosInstance.post("newsletter", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      if (res.data.success) {
        setEmail("");
        notification.open({
          message: "Message Received Successfully ",
          description:
            "Your message has been sent! 🎉 Thank you for reaching out to us. We’re excited to connect and will get back to you shortly. Stay tuned!",
          showProgress: true,
        });
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };
  const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref4, inView4] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref5, inView5] = useInView({ triggerOnce: true, threshold: 0.1 });
  return (
    <div>
      {isLoading && <Loader />}
      <footer className="footer-area" style={{ backgroundColor: "#f1f1f1" }}>
        <div className="container">
          <div className="row">
            <div className={`col-lg-4 col-md-6 aos-init aos-animate footer-animate ${inView1 ? 'visible' : ''}`} ref={ref1}>
              <div className="single-footer-widget">
                <div className="logo">
                  <Link to={`${config.appUrl}`}>
                    <img alt="logo" loading="lazy" width="250" decoding="async" data-nimg="1" src={MainLogo} style={{ color: "transperent" }} />
                  </Link>
                </div>
                <p>Web development and digital marketing are essential for businesses looking to establish a strong online presence. We specialize in creating responsive, user-friendly websites tailored to your brand’s needs. </p>
              </div>
            </div>
            <div className={`col-lg-4 col-md-6 aos-init aos-animate footer-animate ${inView2 ? 'visible' : ''}`} ref={ref2}><div className="single-footer-widget ps-5">
              <h3 className="title-add">Quick Links</h3>
              <ul className="list">
                <li>
                  <Link to={`${config.appUrl}`}>Home</Link>
                </li>
                <li>
                  <Link to={`${config.appUrl}about-us`}>About Us</Link>
                </li>
                <li>
                  <Link to={`${config.appUrl}product`}>
                    Product
                  </Link>
                </li>
                <li>
                  <Link to={`${config.appUrl}contact-us`}>
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>
            </div>
            <div className={`col-lg-4 col-md-6 aos-init aos-animate footer-animate ${inView5 ? 'visible' : ''}`} ref={ref5}>
              <div className="single-footer-widget">
                <h3 className="title-add">Address</h3>
                <ul className="footer-contact-info">
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>E-201, Svayam Sapphire, Opp. Madhuban Resort, <br /> Vithal Udyognagar, GIDC, Anand-388001</li>
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z">
                      </path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>Email : <a href="mailto:info@elementeers.com"> info@elementeers.com</a>
                  </li>
                  <li>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                      </path>
                    </svg>Phone : <a href="tel:+91-8401206515">+91 84012 06515</a> / <a href="tel:+91-9512085180">+91 95120 85180</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="copyright-area">
                <p>Copywrite © 2025. All Rights Reserved
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="developed-area">
                <p>Design and Developed by &nbsp;
                  <Link to="https://cubextechnology.com/" target="_blank" className="footer-id">Cubex Technology</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
